export function isValidKey<T extends object>(
    key: string | number | symbol,
    object: T
): key is keyof T {
    return key in object;
}
